import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField } from "material-ui"
import strings from "../../localization/strings"
import * as api from "../../api"
import AppStateStore from "../../stores/AppStateStore"
import PayPeriodSelector from "../payroll/PayPeriodSelector"
import { IDate } from "../../models"
import * as payrollHelper from "../../helpers/payrollHelper"
import moment from "moment"
interface IProps {
    payGroupId: string
    timecardReferenceDate: IDate
    timecardId: string
    userId: string
    handleClose(): void
    reloadTimecards(msg: string): void
}

interface IState {
    referenceDate: IDate
    errorReferenceDate: string
    reason: string
    errorReason: string
}

export default class ExportDiffTimecardDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            referenceDate: props.timecardReferenceDate,
            errorReferenceDate: null,
            reason: "",
            errorReason: null
        }
        autobind(this)
    }

    handleSave() {
        if (this.checkValidate()) {
            AppStateStore.setProgressSnackbarContent("loading")
            api.exportTimecardDiff(this.props.userId, this.props.timecardId, moment(this.state.referenceDate).utc(true).format(), this.state.reason)
                .then(res => {
                    if (res.data) {
                        this.props.reloadTimecards(strings.Exported_Successfully)
                    }
                    else {
                        AppStateStore.setProgressSnackbarContent(null)
                        AppStateStore.setAlertDialogContent({
                            title: strings.Failed_Export_Timecard_Diff,
                            content: strings.The_timecard_export_is_only_allowed_in_future_unlocked_pay_periods
                        })
                    }
                })
                .catch(err => AppStateStore.setProgressSnackbarContent(err.response.data.message))
            this.props.handleClose()
        }
    }

    checkValidate() {
        let isValid = true

        const timecardReferenceDatePayPeriod = payrollHelper.getPayrollDates(this.props.timecardReferenceDate, this.props.payGroupId)
        const selectedReferenceDatePayPeriod = payrollHelper.getPayrollDates(this.state.referenceDate, this.props.payGroupId)

        if (!moment(timecardReferenceDatePayPeriod.EndDate).isBefore(selectedReferenceDatePayPeriod.StartDate)) {
            this.setState({ errorReferenceDate: strings.Export_pay_period_should_be_future_from_timecard_pay_period })
            isValid = false
        } else {
            this.setState({ errorReferenceDate: null })
        }

        if (!this.state.reason) {
            this.setState({ errorReason: strings.Exporting_Diff_Timecard_Reason_Required })
            isValid = false
        } else {
            this.setState({ errorReason: null })
        }

        return isValid
    }

    render() {
        return (
            <Dialog
                open
                title={strings.Export_Diff_Timecard}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton
                        data-intercom-target={"Break-Btn-CloseAddBreakDialog"}
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"Break-Btn-SaveBreak"}
                        label={strings.Export}
                        primary
                        onClick={this.handleSave}
                    />
                ]}
            >
                <hr />
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    {strings.Export_Diff_Disclaimer}
                    <div style={{ marginTop: 10 }}>
                        <PayPeriodSelector
                            referenceDate={this.state.referenceDate}
                            selectedPayGroupId={this.props.payGroupId}
                            handleChangeDate={(_, payrollDates) => this.setState({ referenceDate: payrollDates.EndDate }, () => this.checkValidate())}
                            hidePrevNextPeriodButtons
                            errorStr={this.state.errorReferenceDate}
                        />
                        <div style={{ width: "87.5%" }}>
                            <TextField
                                data-intercom-target={"Expenses-Export-Entry-Description"}
                                floatingLabelText={strings.Exporting_Diff_Timecard_Reason}
                                value={this.state.reason}
                                onChange={(e, value) => this.setState({ reason: value }, () => this.checkValidate())}
                                fullWidth
                                errorText={this.state.errorReason}
                                errorStyle={{ position: "absolute", bottom: -10 }}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        )
    }
}